module.exports = __webpack_public_path__ + "2b039f2da270f8830eff598309193dad.png";